import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Wordmark, LiveDot } from "./ui";

const LINKS = [
  { label: "Agents", to: "/agents" },
  { label: "How it works", to: "/#how", anchor: true },
  { label: "Industries", to: "/industries" },
  { label: "Pricing", to: "/#pricing", anchor: true },
  { label: "Customers", to: "/company#about" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-all ${scrolled ? "backdrop-blur-md bg-[#050a1f]/85 border-b border-white/[0.06]" : "bg-transparent"}`}>
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <Wordmark />
        <ul className="hidden items-center gap-1 lg:flex">
          {LINKS.map(l => (
            <li key={l.to}>
              {l.anchor ? (
                <a href={l.to.replace("/", "")} className="rounded-full px-4 py-2 text-[14px] text-white/70 hover:text-white hover:bg-white/[0.05]">{l.label}</a>
              ) : (
                <Link to={l.to} className="rounded-full px-4 py-2 text-[14px] text-white/70 hover:text-white hover:bg-white/[0.05]">{l.label}</Link>
              )}
            </li>
          ))}
        </ul>
        <div className="flex items-center gap-2">
          <a href="#demo" className="hidden lg:inline-flex items-center gap-2 rounded-full px-4 py-2 text-[14px] text-white/80 hover:text-white hover:bg-white/[0.05]">
            <LiveDot />
            <span>Live demo</span>
          </a>
          <a href="#book" className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-[14px] font-semibold text-[#051030] hover:-translate-y-0.5 shadow-[0_10px_40px_-10px_rgba(94,234,212,0.5)]">
            Book strategy call
            <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"><path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </a>
          <button className="lg:hidden inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white" onClick={() => setOpen(!open)} aria-label="Menu">
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><path d={open ? "M6 6l12 12M18 6L6 18" : "M4 7h16M4 12h16M4 17h16"} strokeLinecap="round" /></svg>
          </button>
        </div>
      </nav>
      {open && (
        <div className="lg:hidden border-t border-white/[0.06] bg-[#050a1f]/95">
          <ul className="flex flex-col px-6 py-4">
            {LINKS.map(l => (
              <li key={l.to}>
                {l.anchor
                  ? <a href={l.to.replace("/", "")} className="block py-2 text-white/80" onClick={() => setOpen(false)}>{l.label}</a>
                  : <Link to={l.to} className="block py-2 text-white/80" onClick={() => setOpen(false)}>{l.label}</Link>
                }
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}
